export default __webpack_public_path__ + "static/media/Notera.b0fbdd97.ttf";